import { Component, OnInit } from '@angular/core';
import { GetReadyFormFullService } from 'src/app/get-ready-full/shared/get-ready-form.service';
import { ProgressBarService } from 'src/app/progressBar.service';
import { LatamItLoaderService } from 'src/latam-it-loader/latam-it-loader.service';
import { Analytics } from '../../shared/analytics';
import { AdminListEnum } from '../../shared/services/admin-lists/enum/admin-list.enum';
import { ArchiveService } from '../../shared/services/domains/archive/archive.service';
import { LoginService } from '../../shared/services/login.service';
import { AddressFullCommonService } from '../shared/address-common.service';
import { AddressFullFormService } from '../shared/address-form.service';
import { AddressFullNavigationService } from '../shared/address-navigation.service';
import { RoutesAddressFullEnum } from '../shared/enums/routes-address-enum';


@Component({
  selector: 'address-proof',
  templateUrl: './address-proof.component.html',
  styleUrls: ['../shared/address-styles.scss', './address-proof.component.scss'],
})
export class AddressProofFullComponent implements OnInit {
  pageId: string;
  isBtnDisabled: boolean;
  hintObject: any;

  // Parâmetros que vão vir da lista do admin
  uploadParams: any;
  isFileSelected: boolean;

  file = {
    type: '',
  };
  base64: string;
  postFile: boolean;
  isFacebookAndroid: boolean;

  constructor(
    private analyticsLib: Analytics,
    private addressCommonService: AddressFullCommonService,
    private addressFormService: AddressFullFormService,
    public addressNavigationService: AddressFullNavigationService,
    private archiveService: ArchiveService,
    private latamItLoaderService: LatamItLoaderService,
    private loginService: LoginService,
    private progressBarService: ProgressBarService,
    private getReadyFormService: GetReadyFormFullService
  ) {
    this.hintObject = {};
  }



  ngOnInit() {
    this.isFacebookAndroid = this.loginService.deviceInformation.browser_name.toUpperCase() === 'FACEBOOK'
      && this.loginService.deviceInformation.operation_system.toUpperCase() === 'ANDROID';
    this.pageId = 'address-proof';
    this.setFileUploadParams();
    this.resolveHint();
    this.isFileSelected = this.checkFileSelected();
    this.base64 = this.addressFormService.getProperty('addressBase64');
    this.postFile = !this.isFileSelected;
    this.resolveButton(this.isFileSelected);
    this.setProgressBar();
    this.getReadyFormService.setPreviousStage('AddressProof');
    this.analyticsLib.buildData('ComprobanteDomicilio', this.pageId, '9', false);
    this.analyticsLib.trackState(null, null);
    this.addressCommonService.scrollToTop(document);
  }

  setFileUploadParams() {
    this.uploadParams = this.addressCommonService.getAdminList(AdminListEnum.FILE_UPLOAD);
  }

  resolveHint() {
    // tslint:disable-next-line:max-line-length
    this.hintObject.message = `para validar tu domicilio, debés adjuntar una factura de un servicio público o privado que esté a tu nombre.`;
    this.hintObject.value = 'offer';
  }

  checkFileSelected() {
    if (this.addressFormService.getProperty('isFileSelected')) {
      const personalAddress = this.addressFormService.getProperty('personal_address');
      const uploadedAddress = this.addressCommonService.uploadedDocumentAddress;

      if (uploadedAddress) {
        return uploadedAddress.street === personalAddress.street && uploadedAddress.state === personalAddress.state;
      }
    }
    return false;
  }

  fileSelected(event: any) {
    this.file = event.file;
    this.base64 = event.base64;
    this.addressFormService.setProperty('addressBase64', this.base64);
    this.resolveButton(this.base64);
    this.addressFormService.setProperty('isFileSelected', event.isFileSelected);
    this.isFileSelected = event.isFileSelected;
    this.postFile = event.isFileSelected;
    console.log('File event: ', event);
  }

  removeSelectedFile() {
    const event = {
      base64: null,
      isFileSelected: false,
      file: {
        name: null,
        size: null,
        type: null
      }
    };
    this.fileSelected(event);
  }

  resolveButton(base64?) {
    this.isBtnDisabled = !base64;
  }

  continuarButton() {
    if (this.postFile) {
      this.post(this.archiveService.createUploadFileJson(this.base64, this.file.type.split('/')[1], 'address'));
      this.addressCommonService.setUploadedDocumentAddress();
    } else {
      this.addressNavigationService.sendToNext();
    }
  }

  goToFacebookUpload() {
    this.addressNavigationService.navigateTo(RoutesAddressFullEnum.ADDRESS_PROOF_FACEBOOK);
  }

  // TODO: Move the archiveService call to AddressCommonService
  post(fileJson) {
    this.latamItLoaderService.show();
    this.archiveService.doPatchSolicitationFileUpload(fileJson, false, false).subscribe(
      res => {
        if (res.statusCode === 200) {
          console.log('FileUpload post successfull', res);
          this.latamItLoaderService.hide();
          this.addressNavigationService.sendToNext();
        } else {
          console.log('FileUpload post ERROR', res);
          this.latamItLoaderService.hide();
        }
      },
      err => {
        console.log('POST error', err);
        this.latamItLoaderService.hide();
      },
    );
  }

  setProgressBar() {
    this.progressBarService.initializeProgressBar({
      amountLabel: 4,
      currentLabel: 1,
      amountBar: 6,
      currentBar: 6,
      labelName: 'Datos personales',
      nextLabel: 'Siguiente: 2/4 Uso de la cuenta'
    });
  }
}
